import { render, staticRenderFns } from "./HomeProductsCarousel.vue?vue&type=template&id=f98f0b92&scoped=true&"
import script from "./HomeProductsCarousel.vue?vue&type=script&lang=js&"
export * from "./HomeProductsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./HomeProductsCarousel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HomeProductsCarousel.vue?vue&type=style&index=1&id=f98f0b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98f0b92",
  null
  
)

export default component.exports